var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveredIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 70,
    viewBox: "0 0 61 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4987 69.1333L39.3033 55.4083H21.6941L30.4987 69.1333Z",
    fill: "#0D0C22"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 30.25,
    fill: "#0D0C22",
    stroke: "#0D0C22",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 17C23.0544 17 17 23.0544 17 30.5C17 37.9456 23.0544 44 30.5 44C37.9456 44 44 37.9456 44 30.5C44 23.0544 37.9456 17 30.5 17ZM38.3578 26.7643L29.2891 35.833C29.0444 36.2065 28.645 36.4386 28.1942 36.4386C27.7692 36.4386 27.3439 36.2195 27.0992 35.8589L22.6421 31.4147C22.3974 31.17 22.2686 30.848 22.2686 30.5C22.2686 30.1521 22.3974 29.8301 22.6421 29.5854C23.1444 29.083 23.9562 29.083 24.4585 29.5854L28.1812 33.3081L36.5411 24.9483C36.7728 24.7036 37.1078 24.5618 37.4428 24.5618C37.7907 24.5618 38.1127 24.7036 38.3575 24.9483C38.6021 25.18 38.731 25.5021 38.731 25.85C38.731 26.1979 38.6021 26.5199 38.3575 26.7647L38.3578 26.7643Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveredIcn);
export default __webpack_public_path__ + "static/media/delivered_icn.70e7311b1d58529e9ebf61ebaef6cf3c.svg";
export { ForwardRef as ReactComponent };